<template lang='pug'>
  .union-card
    .title 联名权益
    .container(:style="{backgroundImage:`url(${unionData.openCardImgUrl})`}")
      .rights-title {{unionData.additionalName}}
      .button(
        :class="{'button-wait-receive':status===UnionRightsStatus.WAIT_RECEIVE,'button-received':status===UnionRightsStatus.RECEIVED}"
        @click="handleClick"
        ) {{buttonText}}
    aside
      UnionCardRecievedPopup(
        v-if="showPopup"
        :show.sync="showPopup"
        :rightsData="unionData"
        @close="showPopup = false"
        @refreshData="handleRefresh"
      )

</template>
<script>
import { UnionRightsStatus } from '@/const/vip';
import UnionCardRecievedPopup from './union-card-recieved-popup.vue';

export default {
  components: {
    UnionCardRecievedPopup,
  },
  props: {
    unionData: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      UnionRightsStatus,
      showPopup: false,
    };
  },
  computed: {
    status() {
      return this.unionData.status;
    },

    buttonText() {
      if (this.status === UnionRightsStatus.RECEIVED) {
        return '本月已领';
      } if (this.status === UnionRightsStatus.WAIT_RECEIVE) {
        return '去领取';
      }
      return '';
    },
  },
  mounted() {
  },
  methods: {
    handleClick() {
      if (this.status === UnionRightsStatus.WAIT_RECEIVE) {
        this.showPopup = true;
      }
    },
    handleRefresh() {
      this.$emit('refreshData');
    },
  },
};
</script>
<style lang='less' scoped>
.union-card {
  .title {
    font-family: PingFangSC-Medium, PingFang SC, sans-serif;
    font-size: 0.16rem;
    font-weight: 500;
    line-height: 0.22rem;
  }

  .container {
    position: relative;
    display: flex;
    color: #fff;
    margin-top: 0.1rem;
    padding-top: 0.12rem;
    padding-left: 0.12rem;
    border-radius: 0.1rem;
    height: 0.72rem;
    background-size:100%;
    background-repeat: no-repeat;
    display: flex;
    flex-direction: column;

    .left-icon {
      width: 0.2rem;
      height: 0.23rem;
      margin-right: 0.02rem;
    }

    .rights-title {
      font-size: 0.15rem;
    }
    .button{
      position: absolute;
      bottom: 0.12rem;
    }

    .button-received {
      margin-top: 0.06rem;
      color: #fff;
      font-size: 0.12rem;
      font-weight: 400;
      opacity: 0.8;
    }

    .button-wait-receive {
      margin-top: 0.04rem;
      background-color: #fff;
      width: 0.52rem;
      height: 0.22rem;
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 0.06rem;
      color: rgba(125, 59, 42, 1);
      font-size: 0.12rem;
      font-weight: 500;
      line-height: 1;
    }

    .rights-icon {
      width: 0.32rem;
      height: 0.3rem;
      position: absolute;
      right: 0.08rem;
      bottom: 0.05rem;
    }
  }
}
</style>
